import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ProductPackageComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    product: flights.ProductModel;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];
    mounted() {
        const stepNumber = this.product.product.stepNumber;
        const kitId = this.product.product.kitId || '';
        const id = this.product.product.id;
        const label = `product.step${stepNumber}.kit${kitId}.id${id}`;

        if(!this.gaAlreadySubmitted.includes(label)) {
            (<any>this).$ga.sendEvent('product',
                'display',
                label,
                this.gaParams
            );
            this.gaAlreadySubmitted.push(label);
        }
    }

    get relatedProducts() {
        return this.reservation.getPackageRelatedProductsByExternalId(this.product.product.externalId);
    }

    get yandexSuperSms() {
        // @Todo Удалить или отрефакторить yandex код
        return this.reservation.products.find(item => item.product.externalId == 'MegoPackageSuperSms' && item.product.saleType == 'YandexPayButton');
    }

    onProductDetails(product: flights.ProductModel) {
        (<any>this).$ga.sendEvent('product',
            'detail',
            `product.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
            this.gaParams
        );

        (<any>this.$refs).modalProduct.show();
    }

    onProductSelectionChange(value: boolean, from: string) {
        this.product.selected = value;
        (<any>this).$ga.sendEvent('product',
            `${from == 'modal' ? 'detail' : 'btn'}.${value ? 'ok' : 'cancel'}`,
            `product.step${this.product.product.stepNumber}.kit${this.product.product!.kitId || ''}.id${this.product.product.id}`,
            this.gaParams
        );
        if (value) {
            this.product.choiceType = api.ProductChoiceType.manualAccepted;

            console.log('Package!');

            if (this.relatedProducts.length) {
                this.relatedProducts.forEach(relatedProduct => {
                    let productToUnselect: flights.ProductModel | undefined = undefined;

                    if (relatedProduct.criterion == 'equal') {
                        productToUnselect = this.reservation.products.find(product =>
                            product.product.externalId == relatedProduct.externalId
                        );
                    }

                    if (relatedProduct.criterion == 'startsWith') {
                        productToUnselect = this.reservation.products.find(product =>
                            utils.String.startsWith(product.product.externalId, relatedProduct.externalId)
                        );
                    }

                    if (productToUnselect) {
                        // productToUnselect.selected = false;
                    }
                });
            }
        } else {
            this.product.choiceType = api.ProductChoiceType.manualDenied;
        }
        this.$emit('on-product-package-selection-change', this.product, value, 'local-ga');
    }

    onModalProductAdd(from) {
        (<any>this.$refs).modalProduct.hide();
        this.onProductSelectionChange(true, from);

    }

    onModalProductRemove(from) {
        this.onProductSelectionChange(false, from);
        // (<any>this.$refs).modalProduct.hide();
    }
}
